import { render } from "./GlobalModal.vue?vue&type=template&id=5a4ae4fe&scoped=true"
import script from "./GlobalModal.vue?vue&type=script&lang=js"
export * from "./GlobalModal.vue?vue&type=script&lang=js"

import "./GlobalModal.vue?vue&type=style&index=0&id=5a4ae4fe&scoped=true&lang=css"

import exportComponent from "C:\\WSS-BuildAgent\\_work\\5\\s\\Sureload Admin\\sureload-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a4ae4fe"]])

export default __exports__